module.exports = __webpack_public_path__ + "img/nbv-review-outline.8e3fa554.svg";